import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';

export interface Vereador {
  id?: string;
  nome: string;
  apelido?: string;
  legislatura?: string;
  partido?: string;
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
  emExercicio?: boolean;
}
export const ISvereador: Vereador = {
  id: '',
  nome: '',
  apelido: '',
  legislatura: '',
  partido: '',
  dataHoraCriacao: '',
  emExercicio: false,
  usuario: ISusuarioList
};
export interface VereadorList {
  id?: string;
  nome: string;
  apelido?: string;
  legislatura?: string;
  partido?: string;
  dataHoraCriacao?: Date | string;
  emExercicio?: boolean;
  usuario?: UsuarioList;
}
export const ISvereadorList: VereadorList = {
  id: '',
  nome: '',
  apelido: '',
  legislatura: '',
  partido: '',
  dataHoraCriacao: '',
  emExercicio: false,
  usuario: ISusuarioList
};

export interface VereadorDTO {
  id?: string;
  nome: string;
  apelido?: string;
  legislatura?: string;
  partido?: string;
  emExercicio?: boolean;
}
export const ISvereadorDTO: VereadorDTO = {
  id: '',
  nome: '',
  apelido: '',
  legislatura: '',
  partido: '',
  emExercicio: false
};
